var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-equipmentlist"},[_c('h2',{staticClass:"top-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"lists clearfix list-margin"},[_c('div',{domProps:{"innerHTML":_vm.xss.process(_vm._s(_vm.htmlData))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }